import PlayIcon from '@assets/media/mini-play-icon.svg';
import RestartIcon from '@assets/media/restart-icon.svg';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { Button, DefaultButton } from 'common/components/button';
import Icon from 'common/components/Icon';
import variables from 'common/config/variables';
import { Epg } from 'common/constants/data-types';
import { getClassName } from 'common/utils';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getEpisodeInfoText } from './utils';

interface Props {
  // Redux injected
  i18n: any;
  stopped: boolean;
  //
  currentEpg?: Epg;
  epgs?: Epg[];
  hidden?: boolean;
  visible?: boolean;
  onPlay: VoidFunction;
  onBeginning: VoidFunction;
}

function VodPlayButtons(props: Props) {
  const { focusKey, ref } = useFocusable({
    focusKey: 'VOD_PLAY_BUTTONS'
  });
  const BeginIcon = <Icon src={RestartIcon} size="small" />;

  const title = useMemo(() => {
    const title = props.stopped ? props.i18n.common.continue : props.i18n.common.watch;
    if (props.currentEpg && (props.epgs?.length ?? 0) > 1) {
      return `${title} ${getEpisodeInfoText(props.currentEpg?.numeration)}`;
    }
    return title;
  }, [props.epgs, props.currentEpg, props.i18n, props.stopped]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        ref={ref}
        className={getClassName('flex justify-start row vod-play-button-container', {
          visible: props.visible && !props.hidden
        })}
      >
        <DefaultButton
          title={title}
          icon={PlayIcon}
          className="vod-play-button"
          focusKey="VOD_PLAY"
          disabled={!props.visible}
          onEnterPress={props.onPlay}
        />
        {props.stopped && (
          <Button
            title={props.i18n.common.home.toUpperCase()}
            className="vod-beginning-button"
            icon={BeginIcon}
            size="medium"
            backgroundColor={'transparent'}
            focusBackgroundColor={variables.color_grey_20}
            focusColor={variables.color_grey_90}
            fontWeight={700}
            onEnterPress={props.onBeginning}
          />
        )}
      </div>
    </FocusContext.Provider>
  );
}
const mapStateToProps = ({ videoPlayer, i18n }: any) => {
  return {
    i18n,
    stopped: videoPlayer.isStopped
  };
};

export default React.memo(connect(mapStateToProps, {})(VodPlayButtons));
